import React from 'react';

import { Box, Flex } from '@rover/kibble/core';
import type { Props as FlexProps } from '@rover/kibble/core/Flex';
import type { SizeSystemType } from '@rover/kibble/core/styledSystemPropTypes';

import { PAGE_WIDTHS } from './constants';

type ContentWidthOption = 'page' | 'full';

export type Props = FlexProps & {
  contentWidth?: ContentWidthOption;
};

const getMaxWidth = (
  contentWidth: ContentWidthOption,
  maxWidth?: SizeSystemType
): SizeSystemType => {
  if (maxWidth) return maxWidth;

  // if maxWidth isn't specifically provided, contentWidth dictates maxWidth
  // case 'page' (default): use the page layout widths
  // case 'full': use 100%
  if (contentWidth === 'page') return PAGE_WIDTHS;
  return '100%';
};

const Section = ({
  contentWidth = 'page',
  // pulling out maxWidth here means it won't be included in flexProps and we can apply it to the Box instead of the Flex
  maxWidth,
  children,
  ...flexProps
}: Props): JSX.Element => {
  return (
    <Flex data-testid="section" justifyContent="center" paddingX="4x" {...flexProps}>
      <Box width="100%" maxWidth={getMaxWidth(contentWidth, maxWidth)}>
        {children}
      </Box>
    </Flex>
  );
};

export default Section;
